import { Suspense } from "react";
import { Outlet } from "react-router";
import Providers from "@/components/Providers";
import { Loader } from "@/components/common/Loader";

// Full-screen fallback for lazily-loaded PUBLIC routes (no chrome yet). Protected
// routes get their own content-area fallback inside ProtectedLayout.
function AppFallback() {
  return (
    <div className="flex min-h-svh items-center justify-center">
      <Loader size={32} />
    </div>
  );
}

// Root route element: app-wide providers wrapping the matched route's <Outlet/>.
// Providers live inside RouterProvider so auth/socket providers can use
// navigation hooks. The Suspense boundary resolves lazily-loaded route chunks.
export default function App() {
  return (
    <Providers>
      <Suspense fallback={<AppFallback />}>
        <Outlet />
      </Suspense>
    </Providers>
  );
}
